export default ({ request }) => ({
    masterFormulaListApi(data = {}) {
        return request({
            url: '/master/formula/list',
            method: 'post',
            data,
        })
    },
    masterFormulaAddSaveApi(data = {}) {
        return request({
            url: '/master/formula/add/save',
            method: 'post',
            data,
        })
    },
    masterFormulaEditSaveApi(data = {}) {
        return request({
            url: '/master/formula/edit/save',
            method: 'post',
            data,
        })
    },
    masterFormulaDetailApi(data = {}) {
        return request({
            url: '/master/formula/detail',
            method: 'post',
            data,
        })
    },
    masterFormulaDelApi(data = {}) {
        return request({
            url: '/master/formula/del',
            method: 'post',
            data,
        })
    },
    masterFormulaCalculateApi(data = {}) {
        return request({
            url: '/master/formula/calculate',
            method: 'post',
            data,
        })
    },
})
